import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';

import BrandPillarsSection from './BrandPillarsSection';
import DiscoverSection from './DiscoverSection';
import HeroImageSection from './HeroImageSection';
import IntroSection from './IntroSection';
import OurBeliefSection from './OurBeliefSection';
import OurMissionSection from './OurMissionSection';
import OurVisionSection from './OurVisionSection';
import VideoSection from './VideoSection';
import QuickLinksSection from '../../components/QuickLinksSection';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import CompanySection from './CompanySection';
import BreadCrumbMenu from '../../components/BreadCrumbMenus/';
import Placeholder from '../../components/Placeholder';
import { TABLET_P } from '../../constants';

const keyToId = {
  ourBeliefQuickLinkLabel: 'our-belief-section',
  ourMissionQuickLinkLabel: 'our-mission-section',
  ourVisionQuickLinkLabel: 'our-vision-section',
  ourBrandPillarsQuickLinkLabel: 'our-brand-pillars-section',
  ourHeritageQuickLinkLabel: 'our-heritage-section',
  ourAssetsQuickLinkLabel: 'our-assets-section',
  companyProfileQuickLinkLabel: 'company-section',
};

const AboutPage = ({ data, locale, menuInfo }) => {
  const links = [];
  Object.keys(keyToId).forEach(key => {
    if (data[key]) links.push({ id: keyToId[key], label: data[key] });
  });

  return (
    <div>
      {_.get(data, 'metaData') && (
        <Helmet
          title={_.get(data.metaData, 'title')}
          link={[makeCanonicalTagObj(locale, '/about'), ...makeHreflangTagArr(data.metaData.region, '/about')]}
          meta={[
            {
              name: 'description',
              content: _.get(data.metaData, 'description'),
            },
            {
              name: 'keyword',
              content: _.get(data.metaData, 'keyword'),
            },
            // TODO: OGP タグは一旦保留 (2020年01月07日)
            // {
            //   property: 'og:url',
            //   content: _.get(data.metaData, 'url'),
            // },
            // {
            //   property: 'og:type',
            //   content: _.get(data.metaData, 'type'),
            // },
            // {
            //   property: 'og:title',
            //   content: _.get(data.metaData, 'title'),
            // },
            // {
            //   property: 'og:image',
            //   content: _.get(data.metaData, 'image.file.url'),
            // },
            // {
            //   property: 'og:description',
            //   content: _.get(data.metaData, 'description'),
            // },
            // {
            //   property: 'og:site_name',
            //   content: _.get(data.metaData, 'siteName'),
            // },
          ]}
        />
      )}

      {links.length > 0 && <QuickLinksSection links={links} />}

      <VideoSection video={data.heroVideo} />

      <IntroSection title={data.title} description={data.description} />

      <OurBeliefSection
        label={data.copy && data.copy.our_belief}
        title={data.ourBelief}
        description={data.ourBeliefDetails}
      />
      <HeroImageSection image={data.ourBeliefImage} />

      <OurMissionSection
        label={data.copy && data.copy.our_mission}
        title={data.ourMission}
        description={data.ourMissionDetails}
        image={data.ourMissionImage}
      />

      <OurVisionSection
        label={data.copy && data.copy.our_vision}
        title={data.ourVision}
        description={data.ourVisionDetails}
        bios={data.bios}
      />

      <BrandPillarsSection
        label={data.copy && data.copy.our_brand_pillars}
        title={data.ourBrandPillars}
        description={data.ourBrandPillarsDetails}
        brandPillars={data.brandPillars}
      />

      {/* 「OUR HERITAGE」「OUR ASSETS」表示部分 */}
      <DiscoverSection
        cta1={{ image: data.cta1Image, description: data.cta1Description, label: data.cta1Label, url: data.cta1Url }}
        cta2={{ image: data.cta2Image, description: data.cta2Description, label: data.cta2Label, url: data.cta2Url }}
      />

      {/* 会社概要 */}
      {locale === 'ja_jp' && <CompanySection data={data} locale={locale} />}

      <ScrollToTopButton />

      {!(locale && menuInfo && _.get(menuInfo, 'label')) ? (
        <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_P ? '0 0 20px 40px' : '0 0 20px 20px'} />
      ) : (
        <BreadCrumbMenu
          currentPath={`https://www.shiseido-professional.com/${locale}/about`}
          items={[
            {
              name: 'TOP',
              path: `/${locale}/`,
            },
            {
              name: menuInfo.label,
              path: null,
            },
          ]}
        />
      )}
    </div>
  );
};

AboutPage.defaultProps = {
  data: {
    bios: [{ key: 1, person: {} }, { key: 2, person: {} }, { key: 3, person: {} }],
    brandPillars: [{ key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }],
  },
};

AboutPage.propTypes = {
  locale: PropTypes.string.isRequired,
  // ABOUT US メニュー情報 (パンくずリストに必要な情報を含む)
  menuInfo: PropTypes.shape({}).isRequired,
  data: PropTypes.shape(),
};

const mapState = state => ({
  // ABOUT US メニュー情報をキャッシュしておく
  menuInfo: state.siteOptions && state.siteOptions.sitemap ? state.siteOptions.sitemap[0] : {},
});

export default connect(mapState)(AboutPage);



// WEBPACK FOOTER //
// ./src/pages/AboutPage/AboutPage.js